module.exports = __webpack_public_path__ + "static/aeroplanehamper-55f18de6c3367028750670abe61cea26.jpeg";